import React from 'react';

import { MenuItem, Select } from '@mui/material';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';

import type { definitions } from '@luxuryescapes/contract-svc-promo';

import { VOUCHER_CONDITION_TYPES } from '~/components/Vouchers/voucherConditionEditConstants';
import { formatConditionLabel } from '~/components/Vouchers/voucherConditionFormatters';

type ConditionTypeEditCellProps = GridRenderEditCellParams & {
  conditionTypes?: ReadonlyArray<definitions['VoucherConditionV1']['condition_type']>;
  /** Fires when the user picks a new condition type while the cell is in edit mode (before row save). */
  onConditionTypeChange?: (nextType: string) => void;
};

export default function ConditionTypeEditCell({
  id,
  field,
  value,
  conditionTypes,
  onConditionTypeChange,
}: ConditionTypeEditCellProps) {
  const apiRef = useGridApiContext();
  const types = conditionTypes && conditionTypes.length > 0 ? conditionTypes : VOUCHER_CONDITION_TYPES;
  return (
    <Select
      value={value || ''}
      onChange={(event) => {
        const newValue = event.target.value;
        apiRef.current.setEditCellValue({ id, field, value: newValue });
        apiRef.current.setEditCellValue({ id, field: 'condition_details', value: newValue });
        onConditionTypeChange?.(newValue);
      }}
      size="small"
      fullWidth
    >
      {types.map((type) => (
        <MenuItem key={type} value={type}>
          {formatConditionLabel(type)}
        </MenuItem>
      ))}
    </Select>
  );
}
